<template>
     <div>
    <b-card class="card-news-form" header-tag="header" footer-tag="footer">
      <!-- for loading page -->
      <app-loading :className="isLoading ? 'loading' : ''"></app-loading>

        <div slot="header">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
            News Form
          <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">docs</small>
            </a>
          </div>
        </div>
        <div>

          <b-row>
            <b-col sm="12">
              <alert-success :redirectName="'privilege-home'" :show="successMessage != ''"> {{ successMessage }} </alert-success>
              <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>

              <!-- Thumbnail -->
              <b-form-group>
                <div class="text-center">
                  <img class="thumbnail" :src="previewThumbnail" alt="Thumbnail">
                </div>
                <b-input-group>
                <div class="custom-file">
                    <input type="file" class="custom-file-input" @change="changeThumbnailFile">
                    <label class="custom-file-label"> {{ thumbnail.name || 'choose thumbnail file' }} </label>
                </div>
                <b-button variant="outline-secondary" @click="previewThumbnail = '/images/101/thumbnail.png'; thumbnail = {}">
                  Set Default
                </b-button>
                </b-input-group>
              </b-form-group>

              <!-- Zone -->
              <b-form-group>
              <label>Zones</label>
              <v-select v-model="form.zones" multiple :options="zones" :placeholder="'please select zone of privilege'"></v-select>
              </b-form-group>

              <!-- categories -->
              <b-form-group>
              <label>Categories</label>
              <v-select v-model="form.categories" multiple :options="categories" :placeholder="'please select category of privilege'"></v-select>
              </b-form-group>

              <!-- Shop -->
              <b-form-group>
              <label>Shops</label>
              <v-select v-model="form.shops" multiple :options="shops" :placeholder="'please select shops of privilege'"></v-select>
              </b-form-group>

               <!-- Name -->
              <b-form-group>
                <label>Name</label>
                <b-input-group prepend="TH">
                    <b-input :state="feedback(fieldErrors.nameTH)" v-model="form.nameTH" placeholder="กรุณาใส่ชื่อภาษาไทย"></b-input>
                </b-input-group>
                <b-input-group prepend="EN">
                    <b-input :state="feedback(fieldErrors.nameEN)" v-model="form.nameEN" placeholder="please enter english name."></b-input>
                </b-input-group>
              </b-form-group>

              <!-- Details -->
              <b-form-group>
                <label>Details</label>
                <b-input-group prepend="TH">
                    <b-input v-model="form.detailTH" placeholder="กรุณาใส่รายละเอียดภาษาไทย"></b-input>
                </b-input-group>
                <b-input-group prepend="EN">
                    <b-input v-model="form.detailEN" placeholder="please enter english detail."></b-input>
                </b-input-group>
              </b-form-group>

              <!-- Quantity -->
              <b-form-group>
                <label>Quantity</label>
                <b-input-group>
                    <b-input v-model="form.quantity" placeholder="please enter quantity"></b-input>
                </b-input-group>
              </b-form-group>

              <!-- Options -->
              <b-form-group>
                <label>Options</label>
                <b-input-group>
                 <b-form-checkbox v-model="form.canGrab">can keep this privilege as voucher in wallet.</b-form-checkbox>
                </b-input-group>
                <b-input-group>
                 <b-form-checkbox v-model="form.canDecrease">quantity will decrease when using the privilege.</b-form-checkbox>
                </b-input-group>
              </b-form-group>

              <!-- Status -->
              <b-form-group>
                <label>Status</label>
                <b-form-radio-group
                    v-model="form.status"
                    :options="statusOptions"
                ></b-form-radio-group>
              </b-form-group>

              <!-- Showing privilege date -->
              <b-form-group>
                <label>Start - End Showing privilege period</label>
                <v-date-picker
                    mode='range'
                    locale="th-TH"
                    color="gray"
                    :columns="$screens({ default: 1, lg: 2 })"
                    :popover="{ visibility: 'focus' }"
                    :input-props="{ placeholder: 'Please enter showing start-end date', readonly: true }"
                    v-model='form.showingDate'
                    >
                </v-date-picker>
                <b-form-invalid-feedback :state="feedback(fieldErrors.startShowing) && feedback(fieldErrors.startShowing)">
                  Please provide a start-end showing date.
                </b-form-invalid-feedback>
              </b-form-group>

              <!-- active privilege date -->
              <b-form-group>
                <label>Start - End Available privilege period</label>
                <v-date-picker
                    mode='range'
                    locale="th-TH"
                    color="gray"
                    :columns="$screens({ default: 1, lg: 2 })"
                    :popover="{ visibility: 'focus' }"
                    :input-props="{ placeholder: 'Please enter active start-end date', readonly: true }"
                    v-model='form.activeDate'
                    >
                </v-date-picker>
                <b-form-invalid-feedback :state="feedback(fieldErrors.startDuration) && feedback(fieldErrors.endDuration)">
                  Please provide a start-end duration date.
                </b-form-invalid-feedback>
              </b-form-group>

              <!-- Gallery -->
              <b-form-group>
                <b-button variant="ghost-primary" size="sm" @click="showGallery = !showGallery">
                    Galleries {{ showGallery ? 'hide' : 'show'}}
                    <i class="fa fa-folder-open-o" aria-hidden="true"></i>
                </b-button>
                <font class="hint">* Show as sliding banner at the top of application.</font>
                 <app-gallery
                  :show="showGallery"
                  :gallery="form.gallery"
                  :removeGallery="removeGallery">
                </app-gallery>
              </b-form-group>

            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            Back
          </b-button>
          <b-button :disabled="!isActive" @click="savePrivilege" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
          <b-button :disabled="!isActive" v-b-modal.confirmDelete v-if="$route.params.id" type="reset" size="sm" variant="danger">
            <i class="fa fa-ban"></i>
            Delete
          </b-button>
          <alert-confirm
            :id="'confirmDelete'"
            @confirm="deletePrivilege">
            confirm to delete ?
          </alert-confirm>
        </div>
    </b-card>
    </div>
</template>

<script>
import AlertSuccess from '../../components/alert/AlertSuccess';
import AlertConfirm from '../../components/alert/AlertConfirm';
import Loading from '../../components/Loading';
import vSelect from 'vue-select';
import uniqid from 'uniqid';
import Gallery from '../../components/Gallery';

export default {
  data () {
    return {
      successMessage: '',
      errorMessage: '',
      form: {
        zones: null,
        categories: null,
        shops: null,
        nameTH: '',
        nameEN: '',
        detailTH: '',
        detailEN: '',
        quantity: null,
        canGrab: true,
        canDecrease: true,
        status: 'enabled',
        showingDate: {},
        activeDate: {},
        gallery: []
      },
      previewThumbnail: '/images/101/thumbnail.png',
      thumbnail: {},
      isActive: true,
      isLoading: false,
      zones: [],
      categories: [],
      shops: [],
      statusOptions: [
        { text: 'enabled', value: 'enabled' },
        { text: 'disabled', value: 'disabled' }
      ],
      fieldErrors: {},
      showGallery: false,
      removeGallery: [],
      isLoadFinish: []
    };
  },
  methods: {
    deletePrivilege () {
      this.isActive = false;
      this.isLoading = true;
      this.axios.delete(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/privileges/' + this.$route.params.id)
        .then(response => {
          this.handleHttpRequestSuccess();
        })
        .catch(error => {
          this.handleHttpRequestError(error);
        });
    },
    savePrivilege () {
      this.isActive = false;
      this.fieldErrors = {};
      this.isLoading = true;
      const id = this.$route.params.id;
      const bodyFormData = new FormData();
      bodyFormData.append('thumbnail', this.thumbnail);
      bodyFormData.append('zonesId', this.reformatInputList(this.form.zones));
      bodyFormData.append('categoriesId', this.reformatInputList(this.form.categories));
      bodyFormData.append('shopsId', this.reformatInputList(this.form.shops));
      bodyFormData.append('nameTH', this.form.nameTH);
      bodyFormData.append('nameEN', this.form.nameEN);
      bodyFormData.append('detailTH', this.form.detailTH);
      bodyFormData.append('detailEN', this.form.detailEN);
      bodyFormData.append('canGrab', this.form.canGrab);
      bodyFormData.append('canDecrease', this.form.canDecrease);
      bodyFormData.append('status', this.form.status);
      bodyFormData.append('startShowing', this.form.showingDate.start || '');
      bodyFormData.append('endShowing', this.form.showingDate.end || '');
      bodyFormData.append('startDuration', this.form.activeDate.start || '');
      bodyFormData.append('endDuration', this.form.activeDate.end || '');
      bodyFormData.append('removeGallery', this.removeGallery);
      // quantity
      if (this.form.quantity) {
        bodyFormData.append('quantity', this.form.quantity);
      }
      // Gallery
      for (const image of this.form.gallery) {
        bodyFormData.append('gallery', image.file || null);
      }

      if (!id) { // create
        this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/privileges', bodyFormData)
          .then(response => {
            this.handleHttpRequestSuccess();
          })
          .catch(error => {
            this.isActive = true;
            this.handleHttpRequestError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else { // update
        bodyFormData.append('isDeleteThumbnail', '/images/101/thumbnail.png' === this.previewThumbnail);
        this.axios.patch(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/privileges/' + id, bodyFormData)
          .then(response => {
            this.handleHttpRequestSuccess();
          })
          .catch(error => {
            this.isActive = true;
            this.handleHttpRequestError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    changeThumbnailFile (e) {
      this.showThumbnail = false;
      const files = e.target.files || e.dataTransfer.files;
      this.thumbnail = files[0];
      this.previewThumbnail = URL.createObjectURL(this.thumbnail);
      this.showThumbnail = true;
    },
    getListZone () {
      this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/privileges/zones')
        .then(response => {
          const data = response.data;
          if (data) {
            for (const zone of data.data) {
              this.zones.push({
                label: zone.name,
                code: zone.id
              });
            }
          }
          this.isLoadFinish.push('zones');
        })
        .catch(error => {
          this.handleHttpRequestError(error);
        });
    },
    getListCategories () {
      this.axios.get(process.env.VUE_APP_URL_MQDC_API + '/categories', {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(response => {
          const data = response.data;
          if (data) {
            for (const category of data.data) {
              this.categories.push({
                label: category.name,
                code: category.id
              });
            }
          }
          this.isLoadFinish.push('categories');
        })
        .catch(error => {
          this.handleHttpRequestError(error);
        });
    },
    getListShops () {
      this.axios.get(process.env.VUE_APP_URL_MQDC_API + '/shops', {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(response => {
          const data = response.data;
          if (data) {
            for (const shop of data.data) {
              this.shops.push({
                label: shop.name,
                code: shop.id
              });
            }
          }
          this.isLoadFinish.push('shops');
        })
        .catch(error => {
          this.handleHttpRequestError(error);
        });
    },
    reformatInputList (arrayObject) {
      let result = '';
      for (const value of arrayObject || []) {
        result += value.code + ',';
      }
      if (result.length > 0) {
        return result.substring(0, result.length - 1);
      } else {
        return result;
      }
    },
    handleHttpRequestError (error) {
      this.errorMessage = error.message;
      if (error.response) {
        this.errorMessage = error.response.data.message;
        const data = error.response.data.data;
        this.setFieldErrors(data);
      }
    },
    handleHttpRequestSuccess () {
      window.scrollTo(0, 100);
      this.successMessage = 'success';
    },
    setFieldErrors (fields) {
      if (fields) {
        for (const field of fields) {
          this.fieldErrors[field.param] = { message: field.msg, isCorrect: false };
        }
      }
    },
    toObjectURL (file) {
      if (!file) {
        return null;
      }
      if (file.url) {
        return file.url;
      } else {
        return URL.createObjectURL(file.file);
      }
    },
    getFormData () {
      const id = this.$route.params.id;
      if (id) {
        this.isActive = false;
        this.isLoading = true;
        this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + `/mqdc/privileges/${id}`, {
          headers: {
            Accept: 'application/json'
          }
        })
          .then(response => {
            this.isActive = true;
            const data = response.data.data;
            if (!data) {
              throw new Error('data not found');
            }
            this.previewThumbnail = data.thumbnail;
            this.form = {
              zones: data.zones.map(value => this.zones.find(zone => zone.code === value)),
              categories: data.categories.map(value => this.categories.find(category => category.code === value)),
              shops: data.shops.map(value => this.shops.find(shop => shop.code === value)),
              nameTH: data.nameTH,
              nameEN: data.nameEN,
              detailTH: data.detailTH,
              detailEN: data.detailEN,
              quantity: data.quantity,
              canGrab: data.canGrab,
              canDecrease: data.canDecrease,
              status: data.status,
              showingDate: {
                start: data.showing ? new Date(data.showing.start.utc.substring(0, 10)) : null,
                end: data.showing ? new Date(data.showing.end.utc.substring(0, 10)) : null
              },
              activeDate: {
                start: new Date(data.duration.start.utc.substring(0, 10)),
                end: new Date(data.duration.end.utc.substring(0, 10))
              },
              gallery: data.galleries.map(image => { return { id: image.id || uniqid('image-'), url: image.url }; })
            };
          })
          .catch(error => {
            console.log(error);
            this.handleHttpRequestError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        Object.assign(this.$data, this.$options.data());
        this.getListZone();
        this.getListCategories();
        this.getListShops();
      }
    }
  },
  computed: {
    feedback () {
      return data => {
        if (!data) {
          return null;
        } else {
          return data.isCorrect;
        }
      };
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.isLoading = true;
    } else {
      this.isLoading = false;
    }
    this.getListCategories();
    this.getListShops();
    this.getListZone();
  },
  watch: {
    '$route' (to, from) {
      this.getFormData();
    },
    isLoadFinish (to, form) {
      if (3 === this.isLoadFinish.filter(value => 'zones' === value || 'categories' === value || 'shops' === value).length) {
        if (this.$route.params.id) {
          this.getFormData();
        }
      }
    }
  },
  components: {
    AlertSuccess,
    AlertConfirm,
    'app-loading': Loading,
    'v-select': vSelect,
    'app-gallery': Gallery
  }
};
</script>

<style scoped>
    .thumbnail{
      width: auto;
      max-height: 150px;
      -webkit-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      margin-bottom: 5px;
    }
    .hint{
      font-size: 9px;
      color: #f86c6b;
    }
</style>
